import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateFaqsSaga } from "src/store/web-faqs/saga";
import { FaqsDetailDto } from "src/store/web-faqs/type";
import * as Yup from "yup";

const FaqsEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: FaqsDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Faqs.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          ShowWeb: data.ShowWeb,
          ShowApp: data.ShowApp,
          Question: data.Question,
          Answer: data.Answer,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Answer: Yup.string().required(t("Validation.Required").toString()),
          Question: Yup.string().required(t("Validation.Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            updateFaqsSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        multilanguageinputs={[
          {
            field: "Question",
            label: t("Faqs.Question").toString(),
            type: "textarea",
          },
          {
            field: "Answer",
            label: t("Faqs.Answer").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "ShowApp",
            label: t("Faqs.ShowApp").toString(),
            type: "switch",
            col: 6,
          },
          {
            field: "ShowWeb",
            label: t("Faqs.ShowWeb").toString(),
            type: "switch",
            col: 6,
          },
        ]}
      />
    </React.Fragment>
  );
};
export default FaqsEditForm;
